import { Combo } from '@antv/graphin/lib/typings/type';
import { DataSecurityApplicationStatus } from './DataSecurityApplicationStatus';
import { IShape } from '@ant-design/graphs';

export type DataSecurityApplicationOverview = {
	applicationId: number,
	classification?: string;
	installed: boolean;
	read: number;
	stakeholderGroupId?: number;
	status: DataSecurityApplicationStatus;
	write: number;
};

export type ComboDefinition = Combo & {
	id: string,
};

export type Permission = 'read' | 'readwrite';
export type Volume = 'low' | 'high';

export interface GraphEdge extends IShape {
	getPoint: (ratio: number) => {x: number, y: number}
}

export const emptyGraphData = {
	combos: [],
	edges: [],
	nodes: []
};

export const defaultComboForceOptions = {
	comboSpacing: 250,
	linkDistance: 200,
	nodeSpacing: 90,
	preventOverlap: true
};

export const defaultForceOptions = {
	linkDistance: 250,
	nodeSpacing: 40,
	preventOverlap: true
};
